export const PRICE_RANGE = {
  MIN: 0,
  MAX: 1000
} as const;
